module.exports = __webpack_public_path__ + "static/media/relationships.5ab47db2.jpg";